
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'LogoHeader',
  props: {
    mb: {
      type: Boolean,
      default: false,
    },
  },
})
